import React, { useEffect, useState, useRef } from "react";
import { Col, Input, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { FaAngleDoubleDown, FaAngleDoubleUp } from "react-icons/fa";
import { RiArrowDownDoubleFill } from "react-icons/ri";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setRadius,
  setSearchTerm,
  setSelectedSubCategory,
  setSelectedItem,
  setFinalProducts,
  setFinalBwv,
  setActiveTab,
  setViewCustType,
} from "../../../../redux/slices/LcaSlice";
import LcaFilterLogic from "./LcaFilterLogic";

const LcaSideBar = ({
  items,
  productSubCat,
  scrollPopupVisible,
  setScrollPopupVisible,
  isLoading,
}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    searchTerm,
    selectedSubCategory,
    selectedItem,
    radius,
    Lca,
    activeTab,
    bwv,
    searchQuery,
    city,
    month,
    hideSkipped,
    skippedAd,
    totalCount,
    viewCustType,
  } = useSelector((state) => state.lcAds);

  const initialCategoriesToShow = 7;
  const popupRef = useRef();
  const [showPopup, setShowPopup] = useState(false);
  const [visibleCategories, setVisibleCategories] = useState(
    productSubCat.slice(0, initialCategoriesToShow)
  );
  const [showAll, setShowAll] = useState(false);
  const [tempRadius, setTempRadius] = useState(radius[1]); // Temporary state for radius

  function tglhide() {
    var hdel = document.getElementById("lca-sidebar");
    hdel.classList.remove("tgl-show");
    hdel.classList.add("tgl-close");
  }

  const handleToggleShowAll = () => {
    setVisibleCategories(
      showAll ? productSubCat.slice(0, initialCategoriesToShow) : productSubCat
    );
    setShowAll(!showAll);
  };
  const handlePopUpClick = () => {
    window.scrollTo(0, 350);
    setScrollPopupVisible(true);
  };

  const handleSubCategoryClick = (category) => {
    console.log(category, "category");
    handlePopUpClick();
    dispatch(setRadius([1, 1]));
    if (Lca) {
      if (selectedSubCategory && selectedSubCategory.id === category.id) {
        dispatch(setSelectedSubCategory(null));
        dispatch(setActiveTab("Customers"));
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete("tab");
        navigate(
          { pathname: location.pathname, search: searchParams.toString() },
          { replace: true }
        );
      } else {
        dispatch(setSelectedSubCategory(category));
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("tab", category.Name);
        navigate(
          { pathname: location.pathname, search: searchParams.toString() },
          { replace: true }
        );
        if (category.id === 63) {
          dispatch(setActiveTab("Vendor"));
        }
      }
      dispatch(setSelectedItem(null));
    }
  };
  console.log(selectedSubCategory, "category");
  const handleItemClick = (item, ev) => {
    if (selectedItem && selectedItem.subCatItemId === item.subCatItemId) {
      dispatch(setSelectedItem(null));
    } else {
      dispatch(setSelectedItem(item));
    }
    ev.stopPropagation();
  };

  const handleRadiusChange = (event) => {
    const newRadius = event.target.value;
    setTempRadius(newRadius); // Update temporary radius while sliding
  };

  const handleRadiusCommit = () => {
    if (tempRadius > 0) {
      dispatch(setRadius([1, tempRadius])); // Commit radius when sliding stops
    }
  };

  useEffect(() => {
    dispatch(setRadius([1, 1]));
  }, [searchTerm, selectedSubCategory, selectedItem]);

  // useEffect(() => {
  //   if (selectedSubCategory && selectedSubCategory.id == 63) {
  //     if (viewCustType) {
  //       dispatch(setActiveTab("Customers"));
  //       dispatch(setViewCustType(false));
  //     } else {
  //       dispatch(setActiveTab("Vendor"));
  //     }
  //   } else {
  //     dispatch(setActiveTab("Customers"));
  //   }
  // }, [selectedSubCategory]);

  useEffect(() => {
    if (viewCustType) {
      const filterSubCat = productSubCat.filter((item) => item.id === 63);
      console.log(filterSubCat, "filterSubCat");
      dispatch(setSelectedSubCategory(filterSubCat[0]));
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("tab", filterSubCat[0].Name);
      navigate(
        { pathname: location.pathname, search: searchParams.toString() },
        { replace: true }
      );
      // dispatch(setActiveTab("Customers"));
      window.scrollTo(0, 0);
      dispatch(setViewCustType(false));
    }
  }, [viewCustType]);

  useEffect(() => {
    setVisibleCategories(productSubCat.slice(0, initialCategoriesToShow));
  }, [productSubCat]);

  useEffect(() => {
    setTempRadius(radius[1]); // Sync tempRadius with Redux state when it changes
  }, [radius]);

  const Popup = ({ closePopup }) => (
    <div
      className="text-center wc_show_cat_popup d-lg-none d-xl-block d-none"
      style={{ position: "absolute", top: "86px", left: "110px" }}
    >
      <div
        ref={popupRef}
        style={{
          padding: "10px",
          backgroundColor: "rgb(246, 225, 107)",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          zIndex: 999,
          width: 160,
          margin: "-74px auto 10px",
          animation: "flashingRed 2s infinite",
        }}
      >
        <div
          style={{
            fontSize: "12px",
            fontWeight: "bold",
            textWrap: "nowrap",
            marginBottom: "15px",
          }}
        >
          Select an AD type to view
        </div>
        <div
          style={{
            marginTop: "-17px",
            textAlign: "center",
            marginBottom: "-9px",
          }}
          onClick={closePopup}
        >
          <RiArrowDownDoubleFill size={25} />
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(false);
      }
    };
    if (showPopup) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showPopup]);

  useEffect(() => {
    const timer = setTimeout(() => setShowPopup(true), 2500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="categoryList position-relative">
      <LcaFilterLogic
        selectedSubCategory={selectedSubCategory}
        selectedItem={selectedItem}
        searchTerm={searchTerm}
        Lca={Lca}
        bwv={bwv}
        searchQuery={searchQuery}
        radius={radius}
        setFinalProducts={setFinalProducts}
        setFinalBwv={setFinalBwv}
        activeTab={activeTab}
        month={month}
        city={city}
        hideSkipped={hideSkipped}
        skippedAd={skippedAd}
      />
      {!isLoading && showPopup && (
        <Popup closePopup={() => setShowPopup(false)} />
      )}
      <span
        onClick={tglhide}
        className="d-block d-lg-block d-xl-none text-end tgl-filter-close"
        id="tgl-filter-close"
      >
        X
      </span>
      <h5 className="py-4 mb-0">Category</h5>
      <ul
        style={{
          marginBottom: "10px",
          backgroundColor: "#ffffff",
          color: "#000000",
          borderRight: "1px solid rgb(224, 224, 224)",
          padding: "5px 5px 0px 0px",
          height: "100%",
        }}
        className="side-bar"
      >
        {visibleCategories.map((category) => (
          <li
            key={category.id}
            onClick={() => handleSubCategoryClick(category)}
            className={`${selectedSubCategory === category ? "selected" : ""}`}
            style={{
              cursor: "pointer",
              listStyleType: "none",
              borderBottom: "1px solid rgb(224, 224, 224)",
              borderRadius: "0px 25px 0px 25px",
              padding: "15px",
              fontWeight: "bold",
            }}
          >
            {category.Name}
            {selectedSubCategory === category && (
              <div className="items-list">
                <ul>
                  {items
                    .filter((item) => item.subCatId === category.id)
                    .map((item) => (
                      <li
                        key={item.id}
                        onClick={(event) => handleItemClick(item, event)}
                        className={`${
                          selectedItem?.subCatItemName === item?.subCatItemName
                            ? "selected-item"
                            : ""
                        }`}
                        style={{ listStyleType: "none" }}
                      >
                        {item.subCatItemName}
                      </li>
                    ))}
                </ul>
              </div>
            )}
          </li>
        ))}
      </ul>
      <div
        className="show-all-text"
        style={{ color: "blue", textAlign: "right", cursor: "pointer" }}
        onClick={handleToggleShowAll}
      >
        {showAll && productSubCat.length > initialCategoriesToShow
          ? "Show Less"
          : productSubCat.length === initialCategoriesToShow
          ? null
          : "Show All"}
      </div>
      <div>
        <div className="location-filter">
          <h6 style={{ marginBottom: "10px", fontWeight: "bold" }}>Zipcode:</h6>
          <Row>
            <Col xs={8} md={8} xl={12} sm={12} lg={12}>
              <Input
                placeholder="Search Your Zipcode.."
                onChange={(e) => {
                  dispatch(setSearchTerm(e.target.value));
                  dispatch(setRadius([1, 1]));
                }}
                value={searchTerm}
                type="search"
                pattern="[0-9]*"
                onKeyDown={(e) => {
                  if ((e.keyCode < 48 || e.keyCode > 57) && e.keyCode !== 8) {
                    e.preventDefault();
                  }
                }}
              />
            </Col>
            <Col xs={4} md={4} className="d-lg-none d-xl-none p-0">
              <button
                className="btn btn-primary mobile-only m-0"
                onClick={tglhide}
              >
                Search
              </button>
            </Col>
          </Row>
        </div>
        {searchTerm && (
          <div className="radius-slider">
            <h6 style={{ marginBottom: "10px" }}>Radius:</h6>
            <Input
              placeholder="Radius"
              type="range"
              min={1}
              max={50}
              onChange={handleRadiusChange}
              onMouseUp={handleRadiusCommit} // Commit on mouse up
              onTouchEnd={handleRadiusCommit} // Commit on touch end
              value={tempRadius}
              className="w-100"
              step={1}
            />
            <p>{tempRadius} miles</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default LcaSideBar;
